/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tag, Tooltip } from '@fiverr-private/fit';
import { useAttachments, useAttachment } from '../../context/contexts/attachments';
import { ProgressBar } from './ProgressBar';
import classes from './style.module.scss';

export const AttachmentNotConnected = React.memo(({ attachment, removeAttachment, className }) => {

    let progress = 0;
    if (Number.isNaN(attachment.progress)) {
        progress = attachment.loaded ? 100 : 0;
    } else if (attachment.loaded) {
        progress = 100;
    } else {
        progress = attachment.progress || 0;
    }

    const contentClassName = classNames(classes.attachmentContent, 'flex tbody-6', { 'm-l-12': !attachment.loaded });
    const attachmentWrapperClassName = classNames(className, classes.attachmentWrapper);

    return (
        <Tooltip className={attachmentWrapperClassName}
            containerClassName={classes.attachmentItemTooltip}
            content={(
                <span data-testid={`attachment-tooltip-${attachment.id}`}>
                    {attachment.fileName}{attachment.extension} ({attachment.fileSize})
                </span>
            )}>
            <div className="flex" data-testid={`attachment-item-${attachment.id}`}>
                <Tag className={classNames(classes.attachmentItem, classes.attachmentDesign)}
                    borderRadius={Tag.BORDER_RADIUSES.ROUNDED}
                    color={Tag.COLORS.LIGHT_GREY}
                    size={Tag.SIZES.SMALL}
                    handleDismiss={removeAttachment}>
                    {!attachment.loaded && <ProgressBar progressClassName={classes.progressBar}
                        backgroundClassName={classes.progressBar}
                        round percent={progress} size={16}/>}
                    <div className={contentClassName}>
                        <span className={classes.name}>{attachment.fileName}</span>
                        <span>{attachment.extension}</span>
                    </div>
                </Tag>
            </div>
        </Tooltip>
    );
});

AttachmentNotConnected.propTypes = {
    attachment: PropTypes.shape({
        id: PropTypes.string.isRequired,
        loaded: PropTypes.bool,
        progress: PropTypes.number,
        fileName: PropTypes.string.isRequired,
        extension: PropTypes.string.isRequired,
        fileSize: PropTypes.string.isRequired
    }).isRequired,
    className: PropTypes.string,
    removeAttachment: PropTypes.func.isRequired
};

export const Attachment = ({ id, className }) => {

    const { removeAttachment } = useAttachments();
    const attachment = useAttachment(id);

    const remove = React.useCallback(
        () => removeAttachment(id),
        [removeAttachment, id]
    );

    if (attachment === null) {
        return null;
    }

    return <AttachmentNotConnected className={className} attachment={attachment} removeAttachment={remove}/>;
};

Attachment.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string
};
